import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dsp-request-history"
export default class extends Controller {
  static targets = ["modal", "modalTitle", "modalContent", "historyData"]
  static values = { albumId: Number }

  showModal(event) {
    const button = event.currentTarget
    const dspCode = button.dataset.dspCode
    const dspTitle = button.dataset.dspTitle

    // Update modal title
    this.modalTitleTarget.textContent = `${dspTitle} - Request History`

    // Find the history data for this DSP
    const historyDataElement = this.historyDataTargets.find(el =>
      el.dataset.dspCode === dspCode
    )

    if (historyDataElement) {
      // Get the tbody from the hidden table and copy its content
      const tbody = historyDataElement.querySelector('tbody')
      if (tbody) {
        this.modalContentTarget.innerHTML = tbody.innerHTML
      }
    }

    // Show the modal
    this.modalTarget.classList.remove("hidden")
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async cancelRequest(event) {
    const button = event.currentTarget
    const requestId = button.dataset.requestId

    if (!confirm("Are you sure you want to cancel this request?")) {
      return
    }

    button.disabled = true
    button.textContent = "Cancelling..."

    try {
      const response = await fetch(`/albums/${this.albumIdValue}/cancel_dsp_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ request_id: requestId })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        alert(data.error || "Failed to cancel request")
        button.disabled = false
        button.textContent = "Cancel"
      }
    } catch (error) {
      alert("An error occurred. Please try again.")
      button.disabled = false
      button.textContent = "Cancel"
    }
  }
}
